module.exports = __webpack_public_path__ + "static/decorative_do-410e31fa66641feda3daacf7786e89ed.png";